<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import bus from '@/utils/bus';
import settingsChart from '@/components/motlet/settings/chart';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    value: {
      type: Array,
      required: true,
    },
    isPcapOs: Boolean,
  },
  data() {
    return {
      data: {
        value: '',
        type: 'percent',
      },
      title: this.$t('dv.title.mem'),
      chartFieldCode: 'memUsedRate',
    };
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    /**
     * Modified.by.KWShin.2024.03.08.
     * OS 화면은 인스턴스가 single select 모드로 되어 있었으나,
     * 전체를 한꺼번에 볼 수 있게끔 정책 변경을 하므로써,
     * 단일 인스턴스 선택 시에는 해당 인스턴스 값,
     * 전체 인스턴스 선택 시에는 평균값을 보여주도록 로직을 수정함.
     *
     * 그리드 쪽에서 데이터를 읽을 때 전체 혹은 단일 인스턴스의 데이터를 알아서 읽어줌.
     */
    /*  
    setData(data) {
      const [result] = data;
      if (result) this.data.value = parseInt(result.memUsedRate);
      else this.data.value = '';
    },
    */
    setData(dataList) {
      if (dataList.length > 0) {
        let count = 0;
        let sum = 0;
        dataList.forEach(datum => {
          count += 1;
          sum += parseInt(datum[this.chartFieldCode]);
        });
        this.data.value = Math.ceil(sum / count);
      } else this.data.value = '0';
    },
    /**
     * Added.by.KWShin.2026.06.16.
     * 부모가 차트 필드 항목 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 차트 필드 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    chartFieldChanged(code) {
      const chartFieldList = this.isPcapOs ? settingsChart['C_PCAP_OS_MEM'].fields : settingsChart['C_ABAP_OS_MEM'].fields;
      const chartField = chartFieldList.find(f => f.code == code);
      this.title = `${this.$t('dv.title.mem')} (${chartField.text})`;
    },
  },
  created() {
    // BEGIN::Added.by.KWShin.2024.03.12.
    // PcapNetwork.vue 컴포넌트의 모틀릿 Settings에서 차트항목 선택이 변화하면 버스를 통해 신호가 온다.
    bus.$on('update:chartFieldCode-dv/abap/os/mem', chartFieldCode => {
      this.chartFieldCode = chartFieldCode;
      this.chartFieldChanged(chartFieldCode);
    });
    // FINISH::Added.by.KWShin.2024.03.12.
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.12.
    bus.$off('update:chartFieldCode--dv/abap/os/mem');
    // FINISH::Added.by.KWShin.2024.03.12.
  },
};
</script>
